import type { ModalProps } from "./types";
import React, { useEffect, useCallback } from "react";

const ModalComponent: React.FC<ModalProps> = ({ show, children, heigth, width, onClose, title }) => {
	const handleEscapeKey = useCallback(
		(event: KeyboardEvent) => {
			if (event.key === "Escape" && show && onClose) {
				onClose();
			}
		},
		[show, onClose],
	);

	useEffect(() => {
		if (show) {
			document.addEventListener("keydown", handleEscapeKey);
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "unset";
		}

		return () => {
			document.removeEventListener("keydown", handleEscapeKey);
			document.body.style.overflow = "unset";
		};
	}, [show, handleEscapeKey]);

	if (!show) return null;

	return (
		<div
			className={`
         fixed z-50 inset-0 flex justify-center items-center transition-colors
        ${show ? "visible bg-black/20" : "invisible"}
      `}
			role="dialog"
			aria-modal="true"
			aria-labelledby={title ? "modal-title" : undefined}>
			<div
				style={{
					width: `${width}%`,
					maxHeight: `${heigth}%`,
					height: "fit-content",
				}}
				onClick={e => e.stopPropagation()}
				className={`
          bg-white text-black shadow transition-all rounded-lg border overflow-y-auto 
          ${show ? "scale-100 opacity-100" : "scale-125 opacity-0"}
        `}
				role="document"
				tabIndex={-1}>
				{title && (
					<h2 id="modal-title" className="sr-only">
						{title}
					</h2>
				)}
				{children}
			</div>
		</div>
	);
};

export const UserModal = React.memo(ModalComponent);
